var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagOfTheUnitedStates2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 650 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.526316,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1235,
    height: 650,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1235,
    height: 650
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1235,
    height: 650,
    style: {
      fill: "rgb(178,34,52)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,75L1235,75M1235,175L0,175M0,275L1235,275M1235,375L0,375M0,475L1235,475M1235,575L0,575",
    style: {
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 50
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 494,
    height: 350,
    style: {
      fill: "rgb(60,59,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s1",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s2",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s3",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s6",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s41",
    serifId: "s4",
    transform: "matrix(1,0,0,1,41.1667,35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s7",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s8",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s10",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s11",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "s91",
    serifId: "s9",
    transform: "matrix(1,0,0,1,82.3333,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s51",
    serifId: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s42",
    serifId: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s12",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s13",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s14",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s15",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s16",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s43",
    serifId: "s4",
    transform: "matrix(1,0,0,1,41.1667,35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s17",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s19",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s20",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s21",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s181",
    serifId: "s18",
    transform: "matrix(1,0,0,1,164.667,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s92",
    serifId: "s9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s52",
    serifId: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s44",
    serifId: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s22",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s23",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s24",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s25",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s26",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s45",
    serifId: "s4",
    transform: "matrix(1,0,0,1,41.1667,35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s27",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s28",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s29",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s30",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "s93",
    serifId: "s9",
    transform: "matrix(1,0,0,1,82.3333,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s53",
    serifId: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s46",
    serifId: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s31",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s32",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s33",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s34",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s35",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s47",
    serifId: "s4",
    transform: "matrix(1,0,0,1,41.1667,35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s36",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s37",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s38",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s39",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "s94",
    serifId: "s9",
    transform: "matrix(1,0,0,1,329.333,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s54",
    serifId: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s48",
    serifId: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s40",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s49",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s50",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s55",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s56",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s410",
    serifId: "s4",
    transform: "matrix(1,0,0,1,41.1667,35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s57",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s58",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s59",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s60",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "s510",
    serifId: "s5",
    transform: "matrix(1,0,0,1,411.667,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s411",
    serifId: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s61",
    serifId: "s",
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "s62",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s63",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "s64",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "s65",
    serifId: "s",
    transform: "matrix(1,0,0,1,0,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.167,15L52.922,51.18L22.146,28.82L60.188,28.82L29.411,51.18L41.167,15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTheUnitedStates2);
export default __webpack_public_path__ + "static/media/Flag_of_the_United_States2.fe3aeef2ed632b65ae7b2e3d4c117580.svg";
export { ForwardRef as ReactComponent };